respondToVisibility = function (element, callback, parent = null) {
    var options = {
        root: parent,
        threshold: 1
    }

    var observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            callback(entry.isIntersecting > 0);
        });
    }, options);

    observer.observe(element);
}

function pad(str, max) {
    str = str.toString();
    return str.length < max ? pad("0" + str, max) : str;
}

function popup(el) {

    $(".document").toggleClass("no-scroll", true);
    $(".js-popup").toggleClass("active", false);
    $(el).toggleClass("active", true).scrollTop(0);
    return;

}

function popupClose() {

    $(".js-popup").toggleClass("active", false);
    $(".document").toggleClass("no-scroll", false);

    return;

}

$(".js-popup-close").click(function (e) {
    e.preventDefault();
    popupClose();
    return;
});

$("[data-popup]").click(function (e) {

    e.preventDefault();

    var el = $(this).data("popup");
    popup(el);

    return;


});

function initSwipers() {

    if (typeof Swiper === 'undefined') {
        return;
    }

var s4CarouselEl = document.querySelector(".s4 .carousel");
if (s4CarouselEl && !s4CarouselEl.swiper) {
new Swiper(".s4 .carousel", {
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '.s4 .carousel-pagination',
        type: 'custom',
        renderCustom: function (swiper, current, total) {
            return pad(current, 2) + '/' + pad(total, 2);
        }
    },
    navigation: {
        nextEl: ".s4 .carousel-button-next",
        prevEl: ".s4 .carousel-button-prev",
    },
    loop: true,
});
}

var swProductEl = document.querySelector(".sw-container_product");
if (swProductEl && !swProductEl.swiper) {
new Swiper(".sw-container_product", {
	slidesPerView: 1,
	navigation: {
        nextEl: ".sw-next_product",
        prevEl: ".sw-prev_product",
    },
	loop: true,
});
}

var connectEl = document.querySelector('.swiper_connect');
if (connectEl && !connectEl.swiper) {
const connectSwiper = new Swiper('.swiper_connect', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    observer: true,
    observeParents: true,
    navigation: {
        nextEl: '.next-connect',
        prevEl: '.prev-connect',
    },
    breakpoints: {
        1024: {
            slidesPerView: 2,
			spaceBetween: 20,
        },
    },
    on: {
        init: function () {
            setEqualHeight();
        },
        resize: function () {
            setEqualHeight();
        },
    },
});
}

function setEqualHeight() {
    if (window.innerWidth > 1024) {
        const slides = document.querySelectorAll('.swiper_connect .swiper-slide');
        let maxHeight = 0;

        slides.forEach(slide => {
            slide.style.height = 'auto';
        });

        slides.forEach(slide => {
            if (slide.offsetHeight > maxHeight) {
                maxHeight = slide.offsetHeight;
            }
        });

        slides.forEach(slide => {
            slide.style.height = `${maxHeight}px`;
        });
    } else {
        const slides = document.querySelectorAll('.swiper_connect .swiper-slide');
        slides.forEach(slide => {
            slide.style.height = 'auto';
        });
    }
}

var swSingleProductEl = document.querySelector('.sw-single-product');
if (swSingleProductEl && !swSingleProductEl.swiper) {
const thumbSwiper = new Swiper('.sw-thumbs', {
    slidesPerView: 4,
    spaceBetween: 10,
    loop: true,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
});

const mainSwiper = new Swiper('.sw-single-product', {
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    thumbs: {
        swiper: thumbSwiper,
    },
    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: false,
            translate: [0, 0, -400],
        },
        next: {
            translate: ["100%", 0, 0],
        },
    },
});

mainSwiper.on('slideChange', () => {
    const activeIndex = mainSwiper.realIndex;

    document.querySelectorAll('.product-thumbs__slide').forEach(thumb => {
        thumb.classList.remove('swiper-slide-active');
    });

    document.querySelectorAll('.product-thumbs__slide')[activeIndex]?.classList.add('swiper-slide-active');
});
}

var commercialSliderEl = document.querySelector(".commercial_slider");
if (window.innerWidth > 1024 && commercialSliderEl && !commercialSliderEl.swiper) {
	var swiper = new Swiper(".commercial_slider", {
		slidesPerView: 2.6,
		spaceBetween: 20,
		loop: false,
		navigation: false,
		scrollbar: {
        el: ".commercial-scrollbar",
		draggable: true,
      },
	});

	function setCommercialEqualHeight() {
		var maxHeight = 0;
		$('.commercial_slider .swiper-slide .s99-4').each(function() {
			$(this).css('height', 'auto');
			var thisHeight = $(this).outerHeight();
			if (thisHeight > maxHeight) {
				maxHeight = thisHeight;
			}
		});
		$('.commercial_slider .swiper-slide .s99-4').css('height', maxHeight + 'px');
	}

	setCommercialEqualHeight();
	$(window).resize(function() {
		setCommercialEqualHeight();
	});
}

} // end initSwipers

initSwipers();

const appHeight = () => {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
    document.documentElement.style.setProperty('--headroom-height', $("#headroom").innerHeight() + "px");
}

$(window).on("resize", appHeight);

$(window).on("resize", function () {

    $(".mask-appear").each(function (i) {
        lineSplitter($(this));
    });

});

$(window).on("resize", function () {

    $(".floating-cards").each(function (i) {

        var scene = $(this),
            els = scene.find(".floating-cards-wrapper"),
            mh = 0,
            k = 0;

        /* reset to defaults START */

        els.removeAttr("style");

        els.find(".floating-cards-inner").css({
            height: "auto",
        });

        scene.css({
            height: "auto",
        });

        /* reset to defaults END */

        $.each(els, function (j) {

            var el = $(this),
                elh = el.height(),
                hh = el.find(".card-header").innerHeight();

            if (elh > mh) {
                mh = elh;
            }
            if (hh > k) {
                k = hh;
            }

            el.css({

                "z-index": -1 * j,

            });

        });

        els.find(".floating-cards-inner").css({
            height: mh,
        });


        var sceneHeight;

        $.each(els, function (j) {

            $(this).css({

                position: "absolute",
                top: j * k,
                height: mh + (j * mh) - k * j,

            });

            sceneHeight = mh + (j * mh);

        });


        scene.css({
            height: sceneHeight,
        });


        var cards = els.find(".floating-cards-inner");

        $(window).scroll(function (e) {

            var activeCard = 0;

            cards.each(function (j) {

                var topPos = $(this).offset().top - mh + 1,
                    prevCard = cards.eq(j - 1);

                if (prevCard.length) {
                    if (prevCard.offset().top < topPos) {
                        activeCard = j;
                    }
                }

            });

            //cards.eq(activeCard).addClass("active");

            cards.filter(function (c) {
                return c <= activeCard;
            }).addClass("active");

            cards.filter(function (c) {
                return c > activeCard;
            }).removeClass("active");


        });


    });

    $(".section-group .marquee").each(function (j) {

        var trg = $("<div>", {
            class: "marquee-trigger"
        });

        trg.insertBefore($(this));

        $(this).css({
            top: trg.offset().top,
        });
    });

});

/* typeof guard: on 2026-10-15 smartScroll.min.js was commented out of theme.liquid on live and this
   call threw on the privacy/terms/SMS pages, stopping the rest of this file there. */
if ($("[data-scroll]").length && typeof smartScroll !== "undefined") {

    /* The contents links (privacy/terms/SMS) scroll natively: reset.css's smooth scroll-behavior
       and scroll-padding-top do the glide, clear the sticky header and honour reduced motion.
       smartScroll's own jQuery animate fought the CSS smooth scroll (each per-frame scrollTop
       write restarted it) and landed headings under the header, so its click handler is dropped
       and it only keeps the active-item highlight, offset by that same scroll-padding. */
    var smartscroll = smartScroll.init({
        speed: 300,
        addActive: true,
        activeClass: "active",
        offset: parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0,
    }, function () {});
    $("[data-scroll]").off("click");

}




function initScrollMagic() {

    if (typeof ScrollMagic === 'undefined' || typeof TimelineMax === 'undefined') {
        return;
    }

    const controller = new ScrollMagic.Controller();

if ($(".s7").length) {

    new ScrollMagic.Scene({
            triggerElement: ".s7-2",
            duration: $(".s7-2").height(),
            triggerHook: .75,
        })
        .setTween(

            new TimelineMax()
            .to(".s7-2-2", {
                x: "100%",
            })

        )
        .addTo(controller);

}

if ($(".s14").length) {


    var sceneDuration = $(".s14").offset().top + $(".s14").innerHeight() - $(".s14-2-2").offset().top;

    new ScrollMagic.Scene({
            triggerElement: ".s14-2-2",
            duration: sceneDuration,
            triggerHook: 0,
        })
        .setTween(

            new TimelineMax()
            .to(".s14-3-1", {
                rotate: 20,
                scale: .85,
            })

        )
        .addTo(controller);

}

$(".parallax").each(function (i) {

    var b = $(this);
    var img = b.find("img");

    new ScrollMagic.Scene({
            triggerElement: this,
            duration: "100%",
            triggerHook: .5,
        })
        .setTween(

            new TimelineMax()
            .to(img, {
                translateY: 0
            })

        )
        .addTo(controller);


});

} // end initScrollMagic

initScrollMagic();

/* Theme editor: re-run the guarded init routines when a section is added/removed/edited.
   Same typeof guards apply inside initSwipers()/initScrollMagic(), so this is a no-op
   when the relevant libraries aren't loaded on the current template. */
document.addEventListener('shopify:section:load', function () {
    initSwipers();
    initScrollMagic();
});

function lineSplitter(el) {
    var t = el.html(),
        p = t.replace(/(<([^>]+)>)/ig, ''),
        test = $("<span>", {}).css({
            position: "absolute",
            visibility: "hidden",
            height: "auto",
            width: "auto",
            "white-space": "nowrap",
        });
    el.html(null);
    el.append(test);
    var allWords = p.match(/\S+/g);
    var lines = [];
    var currentLine = "";
    for (var i = 0; i < allWords.length; i++) {
        var newLine = currentLine + allWords[i] + " ";
        test.html(newLine);
        if (test.width() > el.width()) {
            lines.push(currentLine.trim());
            currentLine = allWords[i] + " ";
        } else {
            currentLine = newLine;
        }
    }

    lines.push(currentLine.trim());

    for (var i = 0; i < lines.length; i++) {

        var lineWrapper = $("<span>", {
            class: "mask-appear-wrapper",
        }).appendTo(el);

        var line = $("<span>", {
            html: lines[i] + " ",
            class: "mask-appear-inner",
            css: {
                "transition-delay": (1.5 + 0.1 * i) + "s",
            },
        }).appendTo(lineWrapper);


    }

    test.remove();

}

var scrollPosition = 0;


$(function () {


    $(window).trigger("resize");


    var imgLoad = $(".document").imagesLoaded(),
        imgLen = $("img").length,
        imgLoadedNum = 0,
        perc = 0;

    imgLoad.always(function (instance) {

        $(".document").removeClass("loading");

    }).progress(function (instance, image) {

        if (imgLen) {

            imgLoadedNum++;
            perc = parseInt(imgLoadedNum * 100 / imgLen) * -1;
            $(".preloader-curtain").css({
                transform: "translateY(" + perc + "%)",
            });

        }

    });

    $(".header").each(function (i) {
        var headroom = $(this),
            top = 0;

        $(window).on("scroll", function () {

            var wt = $(this).scrollTop(); // + 100;

            if (wt > top) {

                if (!headroom.hasClass("init")) {
                    headroom.addClass("init");
                }

                headroom.toggleClass("active", wt < scrollPosition);

            } else {
                headroom.removeClass("active");
            }


            scrollPosition = wt;

        });

    });

    $(".marquee-container").each(function (i) {

        var b = $(this),
            t = b.find(".marquee-title"),
            w = $(window).width();

        if (b.width() < w) {

            while (b.width() < w) {

                var c = t.clone(true, true);

                c.appendTo(b);

            }

        }

        var runner = b.html(),
            start = $("<div>", {
                class: "runner-start",
                html: runner
            }),
            end = $("<div>", {
                class: "runner-end",
                html: runner
            });

        b.html(null);
        b.append(start);
        b.append(end);

    });

    $(".button").each(function (i) {

        var btn = $(this),
            sptWrapper = $("<span>", {
                class: "button-bubble"
            }),
            spt = $("<span>", {
                class: "button-bubble-inner",
                css: {
                    width: btn.width() * 4,
                    height: btn.width() * 4,
                },
            });

        sptWrapper.appendTo(btn);
        spt.appendTo(sptWrapper);

        btn.on('mouseenter', function (e) {
                var parentOffset = $(this).offset(),
                    relX = e.pageX - parentOffset.left,
                    relY = e.pageY - parentOffset.top;
                spt.css({
                    top: relY,
                    left: relX,
                })
            })
            .on('mouseout', function (e) {
                var parentOffset = $(this).offset(),
                    relX = e.pageX - parentOffset.left,
                    relY = e.pageY - parentOffset.top;
                spt.css({
                    top: relY,
                    left: relX,
                })
            });

    });


});



/* Zoom on hover disabled — re-enable by uncommenting below
if ($(window).width() > 1024) {
    $(".product-gallery .product-image").zoom({
        touch: false,
    });
}
*/





